<section
  class="round-column"
  [class.round-column--final]="round.stage === 'final'"
  [class.round-column--first]="isFirstRound()"
  [class.round-column--last]="isLastRound()"
  [class.round-column--force-outgoing]="forceOutgoingConnector"
  [class.round-column--compact]="compact"
  [style.--card-height.rem]="cardHeightRem()"
  [style.--match-offset.rem]="matchOffsetRem()"
  [style.--match-gap.rem]="matchGapRem()"
  [style.--outgoing-connector-span.rem]="connectorSpanRem()"
>
  <header class="round-head">
    <p class="round-index">Round {{ round.round_number }}</p>
    <h3>{{ round.title }}</h3>
  </header>

  <div class="matches">
    @for (match of round.matches; track match.id; let index = $index) {
      <div
        class="match-node"
        [class.match-node--hide-incoming]="hideIncomingConnector"
        [class.match-node--hide-outgoing]="hideOutgoingConnector()"
        [class.match-node--paired]="isMatchInPair(index)"
        [class.match-node--join-incoming]="joinIncomingConnector"
      >
        <app-tournament-bracket-match-card
          [match]="match"
          [compact]="compact"
          [inactive]="inactiveFinalCard && match.stage === 'final'"
          [inactiveLabel]="inactiveFinalCard && match.stage === 'final' ? inactiveFinalCardLabel : null"
          [reportScoreHref]="reportScoreHrefByMatchId?.get(match.id) ?? null"
          [reportScoreQueryParams]="reportScoreQueryParams"
          [reportScoreLabel]="reportScoreLabelByMatchId?.get(match.id) ?? reportScoreLabel"
        ></app-tournament-bracket-match-card>
        @if (showPairLink(index)) {
          <span class="pair-link" aria-hidden="true"></span>
        }
      </div>
    }
  </div>
</section>
